<template>
  <div class="mobile-home">
    <PaxelBox />
    <Services />
    <Location />
    <Contact />
  </div>
</template>

<script>
import LocalStorage from '@/services/localstorage';
import PaxelBox from './PaxelBox.vue';
import Services from './Services.vue';
import Location from './Location.vue';
import Contact from './Contact.vue';

export default {
  name: 'MobileHome',
  components: {
    PaxelBox,
    Services,
    Location,
    Contact,
  },
  created() {
    setTimeout(() => this.$root.scrollToAnchor(this.$route.hash), 2000);
  },
  mounted() {
    // checking query paramater overduepayment
    const paramOrderId = this.$route.query.orderid;
    if (paramOrderId !== undefined) {
      this.$store.dispatch('getOverdueDropoffDetail', paramOrderId)
        .then((response) => {
          const { overdueStatus } = response;
          switch (overdueStatus) {
            case 'need_to_pay':
              this.redirectOverdue('form');
              break;
            case 'none':
              this.redirectOverdue('success');
              break;
            case 'expired':
              this.redirectOverdue('expire');
              break;
            default:
              this.redirectOverdue();
              break;
          }
        })
        .catch(() => {
          this.redirectOverdue();
        });
    }
    // checking localstorage overdue
    if (LocalStorage.getOverdue() !== null) {
      LocalStorage.removeOverdue();
    }
  },
  methods: {
    redirectOverdue(page) {
      let urlPage = '/';
      if (page === 'success') {
        urlPage = '/overduepayment/success';
      } else if (page === 'expire') {
        urlPage = '/overduepayment/expire';
      } else if (page === 'form') {
        urlPage = '/overduepayment';
      }
      this.$router
        .push({ path: urlPage })
        .then(() => { this.$router.go(); });
    },
  },
};
</script>
<style>
.mobile-home section {
  margin-bottom: 40px;
}
.mobile-home section .section-caption {
  font-family: "GothamBold";
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 40px;
  letter-spacing: 0.24px;
  margin-bottom: 40px;
  color: #5e51a1;
}
</style>
